/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { Options } from '@/types';

const optionsCivilites: Options[] = [
  {
    key: 1,
    text: 'Monsieur',
    value: 1,
  },
  {
    key: 2,
    text: 'Madame',
    value: 2,
  },
];

export default optionsCivilites;
